import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ArrowDown, Sparkles } from 'lucide-react';
import { Button } from '../components/ui/button';

const HeroSphereTest = () => {

  return (
    <div className="pt-20 bg-gray-100 min-h-screen">
      {/* Header */}
      <div className="bg-gray-900 text-white py-6 px-6 text-center">
        <h1 className="text-2xl font-bold">Hero con esfera dorada decorativa</h1>
      </div>

      {/* OPCIÓN 1: Esfera grande sutil detrás del texto */}
      <div className="py-8 px-4">
        <h2 className="text-xl font-bold text-center mb-4 text-[#c9a227]">
          OPCIÓN 1: Esfera grande y sutil detrás del texto
        </h2>
        <div className="max-w-6xl mx-auto">
          <section className="relative min-h-[550px] rounded-2xl overflow-hidden shadow-xl bg-[#faf8f5]">
            {/* Decorative sphere - large, behind text */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px]">
              <div className="w-full h-full rounded-full bg-gradient-to-br from-[#c9a227]/10 via-[#c9a227]/5 to-transparent" />
            </div>
            
            {/* Content */}
            <div className="relative h-full min-h-[550px] flex items-center justify-center">
              <div className="max-w-3xl px-6 text-center">
                <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#c9a227]/10 text-[#c9a227] rounded-full text-sm font-medium mb-8">
                  <Sparkles className="w-4 h-4" />
                  Escuela de Consciencia Akáshica
                </div>
                
                <h1 className="text-5xl lg:text-6xl font-serif text-gray-800 tracking-tight mb-6 leading-[1.1]">
                  Un espacio para
                  <span className="block text-[#c9a227]">volver a ti</span>
                </h1>
                
                <p className="text-xl text-gray-600 max-w-xl mx-auto mb-10">
                  Sin prisa. Sin ruido. De la desconexión a habitar tu vida con claridad.
                </p>
                
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                  <Button className="bg-[#c9a227] hover:bg-[#b89220] text-white px-8 py-6 text-base rounded-full shadow-lg">
                    Descarga el ebook gratuito <ArrowDown className="ml-2 w-4 h-4" />
                  </Button>
                  <Button variant="outline" className="border-[#c9a227] text-[#c9a227] px-8 py-6 text-base rounded-full">
                    Ver formaciones <ArrowRight className="ml-2 w-4 h-4" />
                  </Button>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      {/* OPCIÓN 2: Esfera flotante a la derecha */}
      <div className="py-8 px-4 bg-white">
        <h2 className="text-xl font-bold text-center mb-4 text-[#c9a227]">
          OPCIÓN 2: Esfera flotante a la derecha (asimétrica)
        </h2>
        <div className="max-w-6xl mx-auto">
          <section className="relative min-h-[550px] rounded-2xl overflow-hidden shadow-xl bg-[#faf8f5]">
            {/* Decorative sphere - floating right */}
            <div className="absolute top-1/2 right-[10%] -translate-y-1/2 w-[350px] h-[350px]">
              <div className="w-full h-full rounded-full bg-gradient-to-br from-[#c9a227]/20 via-[#c9a227]/10 to-[#c9a227]/5 shadow-inner" />
              {/* Inner glow */}
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[200px] h-[200px] rounded-full bg-gradient-to-br from-[#c9a227]/30 to-transparent blur-sm" />
            </div>
            
            {/* Content - aligned left */}
            <div className="relative h-full min-h-[550px] flex items-center">
              <div className="max-w-xl px-12 lg:px-16">
                <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#c9a227]/10 text-[#c9a227] rounded-full text-sm font-medium mb-8">
                  <Sparkles className="w-4 h-4" />
                  Escuela de Consciencia Akáshica
                </div>
                
                <h1 className="text-5xl lg:text-6xl font-serif text-gray-800 tracking-tight mb-6 leading-[1.1]">
                  Un espacio para
                  <span className="block text-[#c9a227]">volver a ti</span>
                </h1>
                
                <p className="text-xl text-gray-600 mb-10">
                  Sin prisa. Sin ruido. De la desconexión a habitar tu vida con claridad.
                </p>
                
                <div className="flex flex-col sm:flex-row gap-4">
                  <Button className="bg-[#c9a227] hover:bg-[#b89220] text-white px-8 py-6 text-base rounded-full shadow-lg">
                    Descarga el ebook gratuito <ArrowDown className="ml-2 w-4 h-4" />
                  </Button>
                  <Button variant="outline" className="border-[#c9a227] text-[#c9a227] px-8 py-6 text-base rounded-full">
                    Ver formaciones <ArrowRight className="ml-2 w-4 h-4" />
                  </Button>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      {/* OPCIÓN 3: Múltiples esferas sutiles */}
      <div className="py-8 px-4 bg-gray-100">
        <h2 className="text-xl font-bold text-center mb-4 text-[#c9a227]">
          OPCIÓN 3: Múltiples esferas sutiles (constelación)
        </h2>
        <div className="max-w-6xl mx-auto">
          <section className="relative min-h-[550px] rounded-2xl overflow-hidden shadow-xl bg-[#faf8f5]">
            {/* Multiple spheres */}
            <div className="absolute top-[15%] right-[15%] w-[180px] h-[180px] rounded-full bg-gradient-to-br from-[#c9a227]/15 to-transparent" />
            <div className="absolute bottom-[20%] right-[25%] w-[120px] h-[120px] rounded-full bg-gradient-to-br from-[#c9a227]/10 to-transparent" />
            <div className="absolute top-[30%] left-[10%] w-[100px] h-[100px] rounded-full bg-gradient-to-br from-[#c9a227]/8 to-transparent" />
            <div className="absolute bottom-[15%] left-[20%] w-[80px] h-[80px] rounded-full bg-gradient-to-br from-[#c9a227]/12 to-transparent" />
            <div className="absolute top-[60%] right-[8%] w-[60px] h-[60px] rounded-full bg-gradient-to-br from-[#c9a227]/10 to-transparent" />
            
            {/* Content */}
            <div className="relative h-full min-h-[550px] flex items-center justify-center">
              <div className="max-w-3xl px-6 text-center">
                <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#c9a227]/10 text-[#c9a227] rounded-full text-sm font-medium mb-8">
                  <Sparkles className="w-4 h-4" />
                  Escuela de Consciencia Akáshica
                </div>
                
                <h1 className="text-5xl lg:text-6xl font-serif text-gray-800 tracking-tight mb-6 leading-[1.1]">
                  Un espacio para
                  <span className="block text-[#c9a227]">volver a ti</span>
                </h1>
                
                <p className="text-xl text-gray-600 max-w-xl mx-auto mb-10">
                  Sin prisa. Sin ruido. De la desconexión a habitar tu vida con claridad.
                </p>
                
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                  <Button className="bg-[#c9a227] hover:bg-[#b89220] text-white px-8 py-6 text-base rounded-full shadow-lg">
                    Descarga el ebook gratuito <ArrowDown className="ml-2 w-4 h-4" />
                  </Button>
                  <Button variant="outline" className="border-[#c9a227] text-[#c9a227] px-8 py-6 text-base rounded-full">
                    Ver formaciones <ArrowRight className="ml-2 w-4 h-4" />
                  </Button>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      {/* OPCIÓN 4: Esfera con brillo central (tipo logo) */}
      <div className="py-8 px-4 bg-white">
        <h2 className="text-xl font-bold text-center mb-4 text-[#c9a227]">
          OPCIÓN 4: Esfera con brillo central (referencia al logo)
        </h2>
        <div className="max-w-6xl mx-auto">
          <section className="relative min-h-[550px] rounded-2xl overflow-hidden shadow-xl bg-[#faf8f5]">
            {/* Main sphere with inner glow - referencing logo */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[450px] h-[450px]">
              {/* Outer glow */}
              <div className="absolute inset-0 rounded-full bg-[#c9a227]/5" />
              {/* Middle ring */}
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[300px] h-[300px] rounded-full bg-gradient-to-br from-[#c9a227]/15 to-[#c9a227]/5" />
              {/* Inner bright core */}
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120px] h-[120px] rounded-full bg-gradient-to-br from-[#e8d5a3]/40 via-[#c9a227]/20 to-transparent blur-md" />
              {/* Center point */}
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[40px] h-[40px] rounded-full bg-[#c9a227]/30 blur-sm" />
            </div>
            
            {/* Content */}
            <div className="relative h-full min-h-[550px] flex items-center justify-center">
              <div className="max-w-3xl px-6 text-center">
                <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/80 text-[#c9a227] rounded-full text-sm font-medium mb-8 shadow-sm">
                  <Sparkles className="w-4 h-4" />
                  Escuela de Consciencia Akáshica
                </div>
                
                <h1 className="text-5xl lg:text-6xl font-serif text-gray-800 tracking-tight mb-6 leading-[1.1]">
                  Un espacio para
                  <span className="block text-[#c9a227]">volver a ti</span>
                </h1>
                
                <p className="text-xl text-gray-600 max-w-xl mx-auto mb-10">
                  Sin prisa. Sin ruido. De la desconexión a habitar tu vida con claridad.
                </p>
                
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                  <Button className="bg-[#c9a227] hover:bg-[#b89220] text-white px-8 py-6 text-base rounded-full shadow-lg">
                    Descarga el ebook gratuito <ArrowDown className="ml-2 w-4 h-4" />
                  </Button>
                  <Button variant="outline" className="border-[#c9a227] text-[#c9a227] bg-white/50 px-8 py-6 text-base rounded-full">
                    Ver formaciones <ArrowRight className="ml-2 w-4 h-4" />
                  </Button>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      {/* Instructions */}
      <div className="py-8 bg-gray-900 text-white text-center">
        <h2 className="text-xl font-bold mb-4">¿Cuál te gusta más?</h2>
        <ul className="space-y-2 text-gray-300 max-w-lg mx-auto text-left px-6">
          <li>• <strong>Opción 1:</strong> Esfera grande sutil centrada</li>
          <li>• <strong>Opción 2:</strong> Esfera flotante a la derecha (asimétrica)</li>
          <li>• <strong>Opción 3:</strong> Múltiples esferas pequeñas (constelación)</li>
          <li>• <strong>Opción 4:</strong> Esfera con brillo central (como el logo)</li>
        </ul>
      </div>
    </div>
  );
};

export default HeroSphereTest;
